import { render, staticRenderFns } from "./GenericFieldObjectTypesCheckbox.vue?vue&type=template&id=da2405fa&scoped=true&"
import script from "./GenericFieldObjectTypesCheckbox.vue?vue&type=script&lang=js&"
export * from "./GenericFieldObjectTypesCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./GenericFieldObjectTypesCheckbox.vue?vue&type=style&index=0&id=da2405fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2405fa",
  null
  
)

export default component.exports